import { RiskObservationSource } from "../riskObservation/riskObservationDialog/RiskObservationDialog.types";

export enum PublicRiskObservationState {
    Ready = 0,
    NotFound = 1,
}

export interface PublicRiskObservationLinkViewModel {
    state: PublicRiskObservationState;
    customerName?: string;
    emailLogoBlobId?: string;
}

export interface PublicRiskObservationForm {
    name: string;
    description: string;
    source: RiskObservationSource;
    observedBy: string;
    observedByEmail: string;
}

export enum ReportObservationStep {
    Welcome = 1,
    Observation = 2,
    Source = 3,
    Reporter = 4,
    Success = 5,
}

// Welcome is a splash screen and Success is a receipt, so neither is something the reporter fills in and
// neither belongs in the counter.
export const reportObservationFormSteps = [ReportObservationStep.Observation, ReportObservationStep.Source, ReportObservationStep.Reporter];

export const totalReportObservationSteps = reportObservationFormSteps.length;
